<div *ngIf="item && item.cells" class="grid-cell-ellipsis flex flex-row justify-between items-center">
  <div  class=" full-grow-no-shrink-no-basis ">
    {{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}
  </div>
  <span class="icon"
        [ngClass]="{isPrimaryKey: item.cells['IsPrimaryKey'] && item.cells['IsPrimaryKey'].displayText === 'Yes'}">
    <i class="far fa-key fa-xm inactive" matTooltip="Set Primary Key" (click)="onSetPrimaryKeyClicked()"></i>
    <i class="fas fa-key fa-xm active" matTooltip="Primary Key"></i>
  </span> &nbsp;&nbsp;
  <span (click)="onIconClicked('IsFormulaField')" class="icon"
        [ngClass]="{isFormulaField: item.cells['IsFormulaField'] && item.cells['IsFormulaField'].displayText === 'Yes'}">
    <i class="far fa-function fa-xm inactive" matTooltip="Set Formula Field"></i>
    <i class="fas fa-function fa-xm active" matTooltip="Formula Field"></i>
  </span>
</div>
